export const DEGREE_PROGRAM_OPTIONS = [
  'Technical',
  'Associates',
  'Bachelors',
  'Graduate',
  'Doctoral',
  'Other',
].map((s) => ({ value: s, label: s }));
